export default __webpack_public_path__ + "static/media/lesnik_winter_a_12.971b4952.svg";